<button #downloadManagerOrigin mat-icon-button (click)="openPanel()" [matTooltip]="anyLoading() ? 'Preparing downloads...' : 'Download History'">
  @if (anyLoading()) {
    <mat-progress-spinner diameter="20" mode="indeterminate" strokeWidth="3"></mat-progress-spinner>
  }
  @if (!anyLoading()) {
    <mat-icon class="icon-size-5 dark:text-white" [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
  }
</button>

<ng-template #downloadManagerPanel>
  <div
    class="bg-card fixed inset-0 flex flex-col gap-3 overflow-hidden shadow-[0_0_4px_0_rgba(0,0,0,0.25)] sm:static sm:inset-auto sm:min-h-120 sm:w-90 sm:min-w-90 sm:rounded-2xl">
    <div class="flex items-center justify-between p-6">
      <h1 class="text-xl font-bold">Download history</h1>
      <button mat-icon-button class="inline-flex sm:hidden" (click)="closePanel()">
        <mat-icon class="text-slate-500 icon-size-6" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>

    <div class="flex-1 overflow-auto">
      @for (f of files(); track f) {
        <div class="flex h-15 w-full items-center border-b px-4">
          <div class="flex-1 cursor-pointer truncate text-sm" (click)="downloadFile(f)" [ngClass]="{ 'text-blue-600 underline': f?.isDone }">
            {{ f?.name }}<span class="normal-case">.xlxs</span>
          </div>
          <div class="flex-1 px-2">
            @if (!f.isDone) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
          </div>
          <div class="flex items-center">
            <button mat-icon-button (click)="downloadFile(f)" [disabled]="!f.isDone || !f.url">
              @if (f.isDone) {
                <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:arrow-down-on-square'"></mat-icon>
              }
            </button>
          </div>
        </div>
      }
      <!-- show empty state -->
      @if (files().length === 0) {
        <div class="text-muted flex h-full items-center justify-center text-sm">No downloads</div>
      }
    </div>
  </div>
</ng-template>
